module.exports = __webpack_public_path__ + "static/media/remote-controller.b68ccceb.svg";